import service from "../services/workerTasks.service";

export const workerTasks = {
    namespaced: true,
    state: {
        data: [],
        currentPage: 1,
        lastPage: 1,
        links: [],
        getData: [],
    },
    getters: {
        allData: (state) => state.data,
        pagination: (state) => ({
            currentPage: state.currentPage,
            lastPage: state.lastPage,
        }),
        links: (state) => state.links,
        getData: (state) => state.getData,
    },
    actions: {
        async fetchData({ commit }, params = null) {
            try {
                const response = await service.getAll(params);
                if (response && response.data) {
                    commit('SET_DATA', response.data.data || []);
                    commit('SET_PAGINATION', {
                        currentPage: response.data.current_page || 1,
                        lastPage: response.data.last_page || 1,
                        links: response.data.links || [],
                    });
                }
            } catch (error) {
                console.error("Error fetching worker tasks:", error);
                commit('SET_DATA', []);
                commit('SET_PAGINATION', {
                    currentPage: 1,
                    lastPage: 1,
                    links: [],
                });
            }
        },
        async save(context, data) {
            try {
                let response;
                if (data.id === 0 || !data.id) {
                    response = await service.createData(data);
                } else {
                    response = await service.updateData(data.id, data);
                }
                return response;
            } catch (error) {
                console.error("Error save worker task:", error);
                return error.response;
            }
        },
        async delete({ commit }, id) {
            try {
                const response = await service.deleteData(id);
                commit('REMOVE_DATA', id);
                return response;
            } catch (error) {
                throw error.response;
            }
        },
        async getData({ commit }, id) {
            try {
                const response = await service.getData(id);
                commit('SET_GET_DATA', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getAll() {
            try {
                const response = await service.getAll({ page: 'all' });
                return response.data;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async addPayment(context, { id, amount }) {
            try {
                const response = await service.addPayment(id, amount);
                return response;
            } catch (error) {
                console.error("Error adding payment:", error);
                throw error.response;
            }
        },
        async exportData(context, filters = {}) {
            try {
                const response = await service.exportData(filters);
                return response;
            } catch (error) {
                console.error("Error exporting data:", error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_DATA(state, data) {
            state.data = data;
        },
        SET_PAGINATION(state, pagination) {
            state.currentPage = pagination.currentPage;
            state.lastPage = pagination.lastPage;
            state.links = pagination.links;
        },
        ADD_DATA(state, data) {
            state.data.push(data);
        },
        SET_GET_DATA(state, data) {
            state.getData = data;
        },
        REMOVE_DATA(state, id) {
            state.data = state.data.filter(item => item.id !== id);
        },
    },
};
